import serverEndPoint from './../dxdm';
var Data = [
    {
        "heading" : "Recieved NRPU 2022, one of the competitive HEC grants" ,
        "info" : "We have recieved National Research Program for Universities (NRPU) funding grant of worth PKR. 7,108,500/ for our project “Make Data Useful from Rubble: An AI-based Approach to Digitize Handwritten Medical Prescriptions and to Build a Recommender System”. This is one of the competitve grants from Higher Education Commission (HEC) of Pakistan",        
        "pic" : null,
        "height":"200pt",
        "width":"200pt",
        "webLink" : "https://www.hec.gov.pk/english/services/universities/nrpu/Pages/Introduction.aspx",
        "videoLink":""
    },
    {
        "heading" : "Our paper got accepted in ICDM2021" , 
        "info" : "Our recent work titled \"Gain-Some-Lose-Some: Reliable Quantification Under General Dataset Shift\" by Benjamin Denham, Edmund Lai, Roopak Sinha, and M. Asif Naeem has been accepted in 21st IEEE International Conference on Data Mining, an A* conference in CORE. This year the conference accepted 98 papers out of 990. The acceptance rate was 9.9%.",
        "pic" : `${serverEndPoint}/backup-images/icdm2021.png`,
        "height":"200pt",
        "width":"200pt",
        "webLink" : "",
        "videoLink":"https://ben-denham.github.io/gsls/video/gsls-presentation.mp4"
       
    },

    {
        "heading" : "Our research published in Platinum Journal with IF 8.03" , 
        "info" : "Our recent work titled \"Multi-interest Semantic Changes Over Time in Short-Text Microblogs\" by Herman M. Wandabwa, M. Asif Naeem, Farhaan Mirza, and Russel Pears has been published in Knowledge-Based Systems, a platinum journal with Impact Factor 8.03. To know more about this research work, visit our publication page" ,
        "pic" : `${serverEndPoint}/backup-images/kbs-journal.jpeg`,
        "height":"200pt",
        "width":"200pt",
        "webLink" : "",
        "videoLink":""
    },
    
    {
        "heading" : "Herman Wandabwa has sucessfully completed his PhD" , 
        "info" : "Herman Wandabwa has successfully passed oral defence of his PhD. The topic of his PhD was \"Personalised Taste Profiling in Short-Text Microblogs.\" He has published five outclass research papers in top-ranked journals and conferences based on his PhD research. His research is being supervised by the Data Science Research Group’s founder, Dr Muhammad Asif Naeem.",
        "pic" : `${serverEndPoint}/backup-images/Herman.jpeg`,
        "height":"200pt",
        "width":"200pt",
        "webLink" : "",
        "videoLink":""

    },    
    
    {
        "heading" : "Successfully Organised IWDS 2020" , 
        "info" : "Data Insight lab has successfully organised the 8th International Workshop on Data Science (IWDS 2020) colocated with 15th International Conference on Digital Information Management (ICDIM 2020). This year it was in Luton, UK. The workshop attracted 56 research papers from countries all over the world. This year the paper acceptance rate was 22%.",
        "pic" : `${serverEndPoint}/backup-images/iwds2020.png`,
        "height":"200pt",
        "width":"200pt",
        "webLink" : "https://iwdm.aut.ac.nz/iwds2020/",
        "videoLink":""
    }
]
export default Data;